<template>
  <div
    :class="['message-item p-3 border-bottom', { 'is-unread border-primary bg-light': !isRead, 'border-secondary': isRead }]"
    @click="handleItemClick">

    <div class="d-flex justify-content-between align-items-center">

      <div class="d-flex align-items-start flex-grow-1">

        <div class="message-icon mr-3">
          <i
            v-if="!isRead"
            class="material-icons text-primary">
            info
          </i>
          <i
            v-else
            class="material-icons text-muted">
            info_outline
          </i>
        </div>

        <div class="message-content pr-2">
          <h6 :class="['mb-1', { 'font-weight-bold': !isRead }]">
            {{ message.title }}
          </h6>
          <p
            class="mb-1 text-muted small message-text"
            style="white-space: pre-wrap;">
            {{ message.content }}
          </p>

          <div
            v-if="message.created_at"
            class="message-meta text-muted mt-2 align-middle"
            style="font-size: 12px;">
            <i
              class="material-icons mr-1"
              style="font-size: 12px;">
              access_time
            </i>
            <span>{{ formatDate(message.created_at) }}</span>
          </div>
        </div>
      </div>

      <div
        v-if="!isRead"
        class="message-actions ml-auto mb-auto">
        <i
          class="material-icons text-warning"
          aria-hidden="true"
          :title="$t('systemMessages.badgeNew')"
          style="font-size: 10px;">
          circle
        </i>
      </div>

    </div>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import CalendarUtils from '@/utils/CalendarUtils.js';

export default {
  name: 'system-message-item',
  props: {
    message: {
      required: true,
      type: Object
    }
  },
  computed: {
    isRead () {
      return !!this.message.read_at;
    }
  },
  methods: {
    handleItemClick () {
      if (this.isRead) {
        return;
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/messages/mark-as-read/' + this.message.id,
        successAction: () => {
          this.$emit('refresh');
        }
      });
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return CalendarUtils.formatIsoToHuman(date);
    },
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  transition: background-color 0.2s ease;
  background-color: #fff;
  border-left: 3px solid;

  &.is-unread {
    cursor: pointer;

    &:hover {
      background-color: #f1f5f9 !important;
    }
  }

  .message-icon .material-icons {
    position: relative;
    top: 4px;
  }

  .message-text {
    line-height: 1.4;
  }
}
</style>
